import { AbstractModel } from './AbstractModel'

export class CustomerRallyRoundCrew extends AbstractModel {
    customerId: number|null = null
    rallyRoundId: number|null = null
    task: string|null = null
}
